import React, {FC} from 'react'
import {CanvasMode} from '../model/CanvasMode'
import {
    DiagramIcon,
    MarkdownIcon,
    ReactionIcon,
    ResetScrollIcon,
    SelectIcon,
    ShapeIcon,
    StickyNotesIcon,
    TableIcon,
    TemplateIcon,
    TextIcon,
} from './icons'
import {ToolbarButton} from '../components/ToolbarButton'
import {DocumentIcon, TaskIcon} from '@dv5/components'
import './CanvasToolbar.less'

interface ToolConfig {
    mode: CanvasMode
    icon: FC
    label: string
    title: string
}

const drawingTools: ToolConfig[] = [
    {mode: 'select', icon: SelectIcon, label: 'Select mode', title: 'Select'},
    {mode: 'sticky-notes', icon: StickyNotesIcon, label: 'Sticky notes mode', title: 'Sticky Notes'},
    {mode: 'text-widget', icon: TextIcon, label: 'Text widget mode', title: 'Text Widget'},
    {mode: 'shape', icon: ShapeIcon, label: 'Shape mode', title: 'Shape'},
    {mode: 'reaction', icon: ReactionIcon, label: 'Reaction mode', title: 'Reaction'},
    {mode: 'markdown', icon: MarkdownIcon, label: 'Markdown mode', title: 'Markdown'},
    {mode: 'diagram', icon: DiagramIcon, label: 'Diagram mode', title: 'Diagram'},
    {mode: 'table', icon: TableIcon, label: 'Table mode', title: 'Table'},
    {mode: 'document', icon: DocumentIcon, label: 'Document mode', title: 'Document'},
    {mode: 'task', icon: TaskIcon, label: 'Task mode', title: 'Task'},
]

const extraTools: ToolConfig[] = [
    {mode: 'template', icon: TemplateIcon, label: 'Template mode', title: 'Template'},
]

interface CanvasToolbarProps {
    mode: CanvasMode
    readOnly?: boolean
    onModeChange?: (mode: CanvasMode) => void
    showResetScroll?: boolean
    onResetScroll?: () => void
}

const CanvasToolbarComponent: FC<CanvasToolbarProps> = ({
    mode,
    readOnly = false,
    onModeChange,
    showResetScroll,
    onResetScroll,
}) => {
    const renderTool = (tool: ToolConfig) => (
        <ToolbarButton
            key={tool.mode}
            disabled={readOnly && tool.mode !== "select"}
            active={mode === tool.mode}
            icon={tool.icon}
            label={tool.label}
            title={tool.title}
            onClick={() => onModeChange?.(tool.mode)}
        />
    )

    return (
        <div className='canvas-toolbar'>
            {drawingTools.map(renderTool)}
            <div className='canvas-toolbar__divider' />
            {extraTools.map(renderTool)}
            {showResetScroll && onResetScroll && (
                <>
                    <div className='canvas-toolbar__divider' />
                    <ToolbarButton
                        active={false}
                        icon={ResetScrollIcon}
                        label='Reset scroll position'
                        title='Reset scroll'
                        onClick={onResetScroll}
                    />
                </>
            )}
        </div>
    )
}

export const CanvasToolbar = React.memo(CanvasToolbarComponent)
